<template>
    <Header
        :elements="countElements"
        :current="currentElement"
    ></Header>
    <div class="MuiBox-root css-3d0ymh">
        <div class="MuiBox-root css-19vwmxk" data-testid="screen-business_details" tabindex="-1">
            <div class="MuiBox-root css-1n2tziu">
                <div class="MuiGrid-root MuiGrid-container css-15zova9 slide-up-enter-done" transition="250">
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-3 MuiGrid-grid-md-4 css-4lvwcn">
                        <div class="MuiBox-root css-1yu9eo3">
                            <div class="MuiGrid-root css-skpbsy">
                                <div class="MuiGrid-root css-vnk25j" type="lottie">
                                    <div>
                                        <Freezeframe
                                            src="/images/free-animated-icon-fast-forward-7740748.gif"
                                        ></Freezeframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-1 css-se8e58">
                        <div class="MuiBox-root css-8atqhb"></div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-7 css-xjtbym">
                        <h2>By submitting the form, you agree to The Cohn Legal, PLLC (Headquarters in New York & Massachusetts) <a data-toggle="modal" data-target="#modalTOS" href="#">engagement terms</a>.</h2>
                        <!-- end of TOS -->

                        <SelectServices :list="selectServicesList"></SelectServices>

                        <p class="note-for-revival">(*) - Please Note: If your trademark has gone abandoned because you did not respond to a Likelihood of Confusion Office Action, we will have to draft a legal brief arguing against this objection. The legal fee will then be $850 rather than $250</p>
                    </div>
                </div>
            </div>
            <div class="css-1l6i970">
                <div class="css-1c73k7k">
                    <BottomButton
                        :active="true"
                        @click.native="back"
                        text="Back"
                        class_b="button-back"
                    ></BottomButton>
                    <BottomButton
                        :active="true"
                        @click.native="next"
                        text="Next"
                        class_b="button-next"
                    ></BottomButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Freezeframe from '@/components/Freezeframe.vue'
import Header from '@/components/Header-Short-New.vue'
import BottomButton from '@/ui/Bottom-Button.vue'
import http from "@/api/http";
import SelectServices from "@/components/SelectServices";
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        SelectServices,
        BottomButton,
        Freezeframe
    },
    data() {
        return {
            selectServicesList: [],
            classes: []
        }
    },
    mounted() {
        to_top()
        this.init()
    },
    methods: {
        async init(){
            let { data } = await http.get('trademark-revival/step-3/'  + this.$route.params.key);

            if (data.res) {
                this.classes = data.data.data.classes

                for(let i = 0; i < data.data.data.costs.length; i++){
                    this.selectServicesList.push({
                        name: data.data.data.costs[i].name,
                        quantity: data.data.data.costs[i].quantity,
                        total: data.data.data.costs[i].cost + '.00',
                    })
                }

                this.$store.commit('header/setTotal', data.data.data.total)
            }
        },
        back(){
            let code = this.classes[this.classes.length - 1]['code']
            this.$router.push({ path: '/trademark-revival/step-2/' + code + '/' + this.$route.params.key })
        },
        next(){
            this.$router.push({ path: '/trademark-revival/step-pay/' + this.$route.params.key })
        }
    },
    computed: {
        countElements() {
            return this.classes.length ? 5 + this.classes.length : 0
        },
        currentElement() {
            return this.classes.length ? 5 + this.classes.length - 1 : 0
        }
    }
}
</script>

<style>
.note-for-revival {
    margin-top: 130px;
    display: block;
}
</style>
